import React from 'react';

const EducationalDetails = ({
  formData,
  updateFormData,
  handleSave,
  isEditing,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleQualificationChange = (index, field, value) => {
    const newQualifications = [...(formData.qualifications || [])];
    newQualifications[index] = {
      ...newQualifications[index],
      [field]: value,
    };
    updateFormData({
      ...formData,
      qualifications: newQualifications,
    });
  };

  const addMoreQualification = () => {
    updateFormData({
      ...formData,
      qualifications: [
        ...(formData.qualifications || []),
        {
          type: '',
          programName: '',
          institute: '',
          year: '',
          status: 'completed', // or 'ongoing'
        },
      ],
    });
  };

  const removeQualification = (index) => {
    const newQualifications = (formData.qualifications || []).filter(
      (_, i) => i !== index,
    );
    updateFormData({
      ...formData,
      qualifications: newQualifications,
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Educational Details</h2>

      {/* GCE O/L Details */}
      <div className="p-4 border border-gray-200 rounded-lg space-y-4">
        <h3 className="text-lg font-medium">GCE O/L Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              School
            </label>
            <input
              type="text"
              name="olSchool"
              value={formData?.olSchool || ''}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter school name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Year
            </label>
            <input
              type="number"
              name="olYear"
              value={formData?.olYear || ''}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter year"
              max={new Date().getFullYear()}
            />
          </div>
        </div>
      </div>

      {/* GCE A/L Details */}
      <div className="p-4 border border-gray-200 rounded-lg space-y-4">
        <h3 className="text-lg font-medium">GCE A/L Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              School
            </label>
            <input
              type="text"
              name="alSchool"
              value={formData?.alSchool || ''}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter school name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Year
            </label>
            <input
              type="number"
              name="alYear"
              value={formData?.alYear || ''}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter year"
              max={new Date().getFullYear()}
            />
          </div>
        </div>
      </div>

      {/* Additional Qualifications */}
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-medium">Additional Qualifications</h3>
          <button
            type="button"
            onClick={addMoreQualification}
            className="text-blue-600 hover:text-blue-800"
          >
            + Add Qualification
          </button>
        </div>

        {(formData.qualifications || []).map((qual, index) => (
          <div
            key={index}
            className="p-4 border border-gray-200 rounded-lg space-y-4"
          >
            <div className="flex justify-between items-center">
              <h4 className="font-medium">Qualification #{index + 1}</h4>
              <button
                type="button"
                onClick={() => removeQualification(index)}
                className="text-red-600 hover:text-red-800"
              >
                Remove
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Program Name
                </label>
                <input
                  type="text"
                  name={`qualifications[${index}].programName`}
                  value={qual.programName}
                  onChange={(e) =>
                    handleQualificationChange(
                      index,
                      'programName',
                      e.target.value,
                    )
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter program name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Year of Completion
                </label>
                <input
                  type="number"
                  name={`qualifications[${index}].year`}
                  value={qual.year}
                  onChange={(e) =>
                    handleQualificationChange(index, 'year', e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter year"
                  max={new Date().getFullYear()}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {isEditing && (
        <div className="flex justify-end mt-4">
          <span onClick={handleSave} className="text-blue-600 cursor-pointer">
            Save
          </span>
        </div>
      )}
    </div>
  );
};

export default EducationalDetails;
